import { Component, Input, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { numericalInputOnly } from '../../utils/input-handler/numerical-input-only';
export class TNKDigitalContractComponent implements OnInit {
public submitData: any;
public isBusy: boolean;
public submitValidation: any;
public digitalSignatureData: any;
public verificationSent: boolean;
public isAgreeContractCheckbox: boolean;
public isAgreeContract: boolean;
public inputError: any;
public contractPdfUrl: string;
public numericalInputOnly: any = numericalInputOnly;

   profileData: any;
   loanId: string;
   accessToken: string;
   showModalSucessDigitalContract: any;
   otp1Element: ElementRef;
   otp2Element: ElementRef;
   otp3Element: ElementRef;
   otp4Element: ElementRef;
/**
 * @param {?} api
 * @param {?} http
 */
constructor(public api: ApiConstant,
private http: HttpClient) {
    this.digitalSignatureData = {
      otp_1: null,
      otp_2: null,
      otp_3: null,
      otp_4: null,
    };

    this.inputError = {
      otp: '',
    };

    this.submitValidation = {
      display: false,
      msg: '',
    };

    this.isBusy = false;
    this.isAgreeContract = false;

    this.submitData = {
      signingToken: '',
      loanId: '',
    };

    this.verificationSent = false;
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.contractPdfUrl = `${this.api.apiURL}/loan/contract?tnk_token=${this.accessToken}&loanId=${this.loanId}`;
  }
/**
 * * \@description set submit validation properties
 * * \@arg display (show/hide), text (message)
 * * \@return submitValidation props
 * @param {?} display
 * @param {?} text
 * @return {?}
 */
private setSubmitValidation(display: boolean, text: string) {
    const /** @type {?} */ obj = ( /** @type {?} */((<any>Object))).assign(this.submitValidation, {
      display: display,
      msg: text,
    });
    this.submitValidation = obj;

    return obj;
  }
/**
 * * \@description set submit data properties
 * * \@arg obj (reference object properties of submitData)
 * * \@return submitData object
 * @param {?} obj
 * @return {?}
 */
private setSubmitData(obj: any) {
    const /** @type {?} */ submitData = ( /** @type {?} */((<any>Object))).assign(this.submitData, obj);
    this.submitData = submitData;

    return this.submitData;
  }
/**
 * * \@description resend OTP Code (smsToken)
 * * \@arg none
 * * \@method resendVerificationCode()
 * * \@return void
 * @return {?}
 */
public resendVerificationCode() {
    if (!this.verificationSent) {
      this.verificationSent = true;
      this.submitContract();
    }
  }
/**
 * * \@description submit agree contract by user.
 * * \@return void
 * @return {?}
 */
public submitContract() {
    if (!this.isBusy) {
      this.isBusy = true;
      this.setSubmitValidation(false, '');

      this.setSubmitData({
        loanId: this.loanId ? this.loanId : '',
      });

      // first path here and error handling
      this.http
        .post(
          `${this.api.apiURL}/loan/contract/authenticate/1?tnk_token=${this.accessToken}`,
          this.submitData,
        )
        .subscribe(
          (data: any) => {
            this.isAgreeContract = true;
            this.isBusy = false;
            this.verificationSent = false;
          },
          (error: HttpErrorResponse) => {
            this.isBusy = false;
            this.verificationSent = false;

            this.setSubmitValidation(
              true,
              'Mohon maaf, Anda belum bisa melanjutkan ke tanda tangan kontrak. Cobalah beberapa saat lagi.',
            );
            // console.log(error);
          },
        );
    }
  }
/**
 * * \@description submit the signature by otp
 * * \@return void
 * @return {?}
 */
public submitOTPSignature() {
    if (!this.isBusy && this.checkOTPComplete()) {
      this.isBusy = true;
      this.setSubmitValidation(false, '');

      const /** @type {?} */ otp: string = `${this.digitalSignatureData.otp_1}${this.digitalSignatureData.otp_2}${this.digitalSignatureData.otp_3}${this.digitalSignatureData.otp_4}`;

      this.setSubmitData({
        loanId: this.loanId ? this.loanId : '',
        signingToken: otp,
      });

      // second path here and error handling
      this.http
        .post(
          `${this.api.apiURL}/loan/contract/authenticate/2?tnk_token=${this.accessToken}`,
          this.submitData,
        )
        .subscribe(
          (data: any) => {
            // digital signature success
            this.isBusy = false;
            location.reload();
          },
          (error: HttpErrorResponse) => {
            // handling here
            // tslint:disable-next-line
            console.log(error);
            const /** @type {?} */ err = error;
            this.isBusy = false;

            if (err.status >= 400 && err.status < 500) {
              const /** @type {?} */ data = err.error;
              this.isBusy = false;
              // tslint:disable-next-line
              console.log(data);

              if (data.result && data.result.errors[0].code === 1000) {
                this.setSubmitValidation(
                  true,
                  'Mohon maaf, kode OTP yang anda masukkan tidak sesuai, silahkan cek kembali atau kirim ulang kode OTP',
                );
              } else {
                this.setSubmitValidation(
                  true,
                  'Mohon maaf, Anda belum bisa melanjutkan ke tanda tangan kontrak. Cobalah beberapa saat lagi.',
                );
              }
            }
          },
        );
    } else {
      this.isBusy = false;
      this.setSubmitValidation(true, 'Kode OTP tidak boleh kosong');
    }
  }
/**
 * * \@description handle input for OTP input (type / keydown)
 * * \@arg id (element next id), evt (element input)
 * * \@return void
 * @param {?} id
 * @param {?} evt
 * @return {?}
 */
private OTPInputTab(id: string, evt: any) {
    if (evt.inputType !== 'deleteContentBackward') {
      if (evt.target.value.length > evt.target.maxLength) {
        const /** @type {?} */ value = evt.target.value.substr(evt.target.value.length - 1);
        evt.target.value = null;
        evt.target.value = value;
      }

      if (id === 'otp_2') {
        this.otp2Element.nativeElement.focus();
      } else if (id === 'otp_3') {
        this.otp3Element.nativeElement.focus();
      } else if (id === 'otp_4') {
        this.otp4Element.nativeElement.focus();
      }
    }
  }
/**
 * * \@description handle input for OTP input (backspace)
 * * \@arg id (element next id), evt (element input)
 * * \@return void
 * @param {?} id
 * @param {?} evt
 * @return {?}
 */
private OTPBackspaceTab(id: string, evt: any) {
    evt.target.value = null;

    setTimeout(() => {
      if (id === 'otp_1') {
        this.otp1Element.nativeElement.focus();
      } else if (id === 'otp_2') {
        this.otp2Element.nativeElement.focus();
      } else if (id === 'otp_3') {
        this.otp3Element.nativeElement.focus();
      } else if (id === 'otp_4') {
        this.otp4Element.nativeElement.focus();
      }
    }, 50);
  }
/**
 * @return {?}
 */
public checkOTPComplete() {
    const /** @type {?} */ otp: string = `${this.digitalSignatureData.otp_1}${this.digitalSignatureData.otp_2}${this.digitalSignatureData.otp_3}${this.digitalSignatureData.otp_4}`;

    return otp.length === 4 ? true : false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  template: `
    <div class="digital-contract">
      <ng-container *ngIf="!isAgreeContract">
        <div class="digital-contract__agreement">
          <p>
            Berikut adalah kontrak pinjaman Anda. Mohon mengunduh dan membaca dengan
            teliti kontrak tersebut.
          </p>
          <div class="digital-contract__btn-download tnk-margin-bottom--base">
            <a href="{{ contractPdfUrl }}">
              <span class="tnk-color--secondary">
                <i class="fa fa-1x fa-download"></i>
                <strong style="text-decoration: underline;">
                  Unduh file kontrak pinjaman
                </strong>
              </span>
            </a>
          </div>

          <div class="digital-contract__checkbox tnk-padding--base">
            <label class="tnk-checkbox">
              <input type="checkbox" [(ngModel)]="isAgreeContractCheckbox" />
              Saya telah membaca dan menyetujui Kontrak Pinjaman yang terlampir di
              halaman ini. Dengan demikian saya menyetujui untuk menjalankan hak dan
              kewajiban sesuai yang tertera dalam kontrak pinjaman dan sesuai dengan
              hukum yang berlaku di indonesia.
            </label>
            <div class="digital-contract__btn-confirm tnk-margin-top--large ">
              <button
                (click)="submitContract()"
                [disabled]="!isAgreeContractCheckbox"
                class="tnk-button tnk-button--primary"
              >
                Lanjut tanda tangan kontrak
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isAgreeContract">
        <div class="digital-contract__otp">
          <ul class="tnk-list tnk-list--check">
            <li class="tnk-list__item">
              Kami Telah mengirim kode verifikasi ke No. HP anda:
              <strong>{{ profileData && profileData.phone }}</strong>
            </li>
            <li class="tnk-list__item">
              Masukan
              <strong>kode verifikasi sebagai tanda kontrak online Anda</strong>
            </li>
            <li class="tnk-list__item">
              Hubungi 02140005859 atau 02130005859 untuk mengubah nomor handphone.
            </li>
          </ul>

          <div class="login__block">
            <p>Kode Akses baru saja dikirim ke handphone anda</p>
            <div class="row">
              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  maxlength="1"
                  #otp_1
                  id="login_otp1"
                  [(ngModel)]="digitalSignatureData.otp_1"
                  (input)="OTPInputTab('otp_2', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_2
                  maxlength="1"
                  id="login_otp2"
                  [(ngModel)]="digitalSignatureData.otp_2"
                  (input)="OTPInputTab('otp_3', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_1', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_3
                  maxlength="1"
                  id="login_otp3"
                  [(ngModel)]="digitalSignatureData.otp_3"
                  (input)="OTPInputTab('otp_4', $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_2', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>

              <div class="col-sm-3 col-xs-3 col-3">
                <input
                  type="number"
                  class="form-control otp--input"
                  #otp_4
                  maxlength="1"
                  id="login_otp4"
                  [(ngModel)]="digitalSignatureData.otp_4"
                  (input)="OTPInputTab(null, $event)"
                  (keypress)="numericalInputOnly($event)"
                  (keydown.backspace)="OTPBackspaceTab('otp_3', $event)"
                  (focus)="$event.target.select()"
                  (click)="$event.target.select()"
                />
              </div>
            </div>
          </div>
          <div class="login__block">
            <button
              class="tnk-button tnk-button--primary"
              disabled
              [disabled]="isBusy && checkOTPComplete()"
              (click)="submitOTPSignature()"
              id="login_btn_step3"
            >
              {{ isBusy ? 'Mohon menunggu...' : 'Tanda Tangan Kontrak' }}
            </button>

            <p
              id="pinjamlagi_KirimUlangKode"
              class="description"
              *ngIf="!verificationSent"
            >
              Belum menerima kode?
              <a
                class="tnk-color--primary"
                href="javascript:void(0)"
                (click)="resendVerificationCode()"
                id="login_link_resendverification"
              >
                Kirim ulang kode
              </a>
            </p>

            <p class="description" *ngIf="verificationSent">
              Kode akses sedang dikirim, mohon menunggu
            </p>
          </div>
        </div>
      </ng-container>
      <div class="digital-contract__otp">
        <div class="login__block" *ngIf="submitValidation.display">
          <div class="block__info error--block">
            <p>{{ submitValidation.msg }}</p>
          </div>
        </div>
      </div>
    </div>
  `,
  selector: 'tnk-digital-contract',
  styles: [`
    .pd-left-right-20 {
      padding-left: 20px;
      padding-right: 20px;
    }
    .separator {
      position: relative;
      width: 100%;
      height: 1px;
      display: block;
      overflow: hidden;
      background-color: #ececec;
      margin: 5px auto;
    }
    .separator:after {
      content: ' ';
    }
    .table.table--borderless td,
    .table.table--borderless th {
      border: none;
    }
    .table.table--borderless td {
      font-size: 14px;
    }
    .separator {
      position: relative;
      display: block;
      height: 1px;
      width: 100%;
      background-color: #ccc;
      margin-bottom: 10px;
    }
    .no--margin {
      margin: 0 !important;
    }
    a.link {
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
    }
    a.link.link--clr-blue:link {
      color: #004c7b;
    }
    .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group {
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
    }
    .form-wrapper .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group .help-block {
      font-size: 13px;
    }
    .form-wrapper .form-group .help-block.label--control {
      color: #444;
    }
    .form-wrapper .form-group .col-sm-* p {
      margin-bottom: 15px;
    }
    a.tnk__button {
      text-decoration: none;
    }
    .tnk__button {
      position: relative;
      display: inline-block;
      min-width: 70px;
      padding: 10px;
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      outline: 0;
      cursor: pointer;
      border: 1px solid transparent;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin: 0 auto;
      border-radius: 35px;
      -webkit-box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
              box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
      text-transform: uppercase;
      margin-top: 15px;
    }
    .tnk__button[disabled] {
      cursor: not-allowed;
    }
    .tnk__button.button--sm {
      font-size: 12px;
    }
    .tnk__button.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
    }
    .tnk__button.button--block {
      min-width: 100%;
      width: 100%;
      padding: 10px 0;
    }
    .tnk__button.button--float-right {
      float: right;
      margin-right: 10px;
    }
    .tnk__button.button--float-left {
      float: left;
      margin-left: 10px;
    }
    .tnk__button.button--min {
      width: 110px;
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    .tnk__button.button--green {
      font-size: 12px;
      color: #fff;
      background-color: #81be41;
    }
    .tnk__button.button--green.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--green:hover {
      background-color: #72b63e;
    }
    .tnk__button.button--green:active {
      color: #f2f2f2;
      bakground-color: #6ab631;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--green[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--green.button--sm {
      -webkit-box-shadow: none;
              box-shadow: none;
      padding: 8.5px 10px;
    }
    .tnk__button.button--blue {
      background-color: #1a72a4;
      color: #fff;
      font-size: 12px;
    }
    .tnk__button.button--blue.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--blue:hover {
      background-color: #1e6a94;
      color: #fff;
    }
    .tnk__button.button--blue:active {
      color: #f2f2f2;
      background-color: #004c7b;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--blue[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--blue.button--min {
      font-size: 10px;
    }
    .tnk__button.button--red {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole {
      border-radius: 16.5px;
      padding: 7px 10px;
    }
    .tnk__button.button--hole.button--red {
      background-color: #fff;
      border: 2px solid #721c24;
      color: #721c24;
    }
    .tnk__button.button--hole.button--red:hover,
    .tnk__button.button--hole.button--red :active {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole.button--green {
      background-color: transparent;
      border: 2px solid #81be41;
      color: #81be41;
    }
    .tnk__button.button--hole.button--green.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--green.button--active {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--green.button--active:hover,
    .tnk__button.button--hole.button--green.button--active :active {
      background-color: #6ab631;
    }
    .tnk__button.button--hole.button--green:hover {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue {
      background-color: transparent;
      border: 2px solid #1a72a4;
      color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--blue.button--active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue.button--active:hover,
    .tnk__button.button--hole.button--blue.button--active :active {
      background-color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue:hover,
    .tnk__button.button--hole.button--blue :active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue[disabled] {
      border: 2px solid transparent;
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--margin-sm {
      margin-top: 5px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button.button--margin-md {
      margin-top: 10px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button .icon {
      margin-right: 10px;
    }
    .tnk__modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5000;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background-color: rgba(0,0,0,0.75);
    }
    .tnk__modal .modal__inner {
      position: relative;
      border-radius: 8px;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
              box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
      width: 80%;
      min-height: 240px;
      margin: 7.5% auto 0;
      display: block;
    }
    .tnk__modal .modal__inner.modal--size-small {
      width: 30%;
      border-radius: 8px;
      min-height: 120px;
      margin: 0 auto;
    }
    .tnk__modal .modal__inner.modal--size-small .modal__content {
      margin-top: 25vh;
      padding: 30px;
    }
    .tnk__modal .modal__inner .modal__content {
      position: relative;
      display: block;
      overflow: hidden;
    }
    .tnk__modal .modal__inner .modal__content.content--align-center {
      text-align: center;
    }
    .tnk__modal .modal__inner .modal__content h4 {
      font-size: 22px;
      color: #81be41;
    }
    .tnk__modal .modal__inner .modal__content .head__icon {
      font-size: 48px;
    }
    .tnk__modal .modal__inner .modal__content p {
      color: #8a8989;
      margin-top: 28px;
    }
    .checkbox__wrapper {
      position: relative;
      display: block;
      overflow: hidden;
      background-color: #cfe6f0;
      padding: 20px 30px;
      border-radius: 5px;
      margin: 0 0 10px;
    }
    .checkbox__wrapper.has-error {
      background-color: #f2dede;
    }
    .checkbox__wrapper.has-error p {
      color: #721c24;
    }
    .checkbox__wrapper label {
      color: #191919;
    }
    .checkbox__wrapper label input[type=checkbox] {
      width: 16px;
      height: 16px;
      margin-left: -25px;
      margin-top: 3px;
    }
    .birth__province {
      padding-left: 0 !important;
    }
    .birth__city {
      padding-right: 0 !important;
    }
    @media screen and (min-width: 240px) and (max-width: 800px) {
      .birth__province {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .birth__city {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .tnk__button.button--margin-sm {
        min-width: 42.5%;
      }
      .tnk__button.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--hole.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--float-left {
        margin-left: 0;
      }
      .tnk__modal .modal__inner.modal--size-small {
        width: 100%;
        border-radius: 0;
        min-height: 100vh;
      }
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        margin-top: 0;
        padding: 0;
        padding-top: 25vh;
      }
    }
    @media screen and (max-width: 1024px) {
      .tnk__button.button--hole.button--green:active {
        background-color: #81be41;
        color: #fff;
      }
    }
    @media screen and (min-width: 1024px) {
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        padding-top: 25;
      }
      .checkbox__wrapper {
        margin: 0 0 10px;
      }
    }
    .digital-contract .digital-contract__agreement {
      margin-bottom: 20px;
    }
    .digital-contract .digital-contract__agreement .digital-contract__btn-download,
    .digital-contract .digital-contract__agreement .digital-contract__checkbox,
    .digital-contract .digital-contract__agreement .digital-contract__btn-confirm {
      margin-top: 20px;
    }
    .digital-contract .digital-contract__agreement .digital-contract__checkbox {
      background-color: rgba(204,204,204,0.2);
    }
    .digital-contract .digital-contract__otp {
      position: relative;
      display: block;
      padding: 10px;
      overflow-x: hidden;
    }
    .digital-contract .digital-contract__otp .login__block {
      position: relative;
      width: 100%;
      display: block;
      margin: 20px auto;
      margin-top: 30px;
      text-align: center;
    }
    @media screen and (min-width: 767px) {
      .digital-contract .digital-contract__otp .login__block {
        width: 70%;
      }
    }
    @media screen and (min-width: 1110px) {
      .digital-contract .digital-contract__otp .login__block {
        width: 50%;
      }
    }
    .digital-contract .digital-contract__otp .login__block .input-group {
      width: 100%;
      margin-top: 18px;
    }
    .digital-contract .digital-contract__otp .login__block .tnk__button {
      margin-top: 53px;
      margin-bottom: 26px;
    }
    .digital-contract .digital-contract__otp .login__block .otp--input {
      height: 83px;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      -moz-appearance: textfield;
    }
    .digital-contract .digital-contract__otp .login__block .otp--input::-webkit-inner-spin-button,
    .digital-contract .digital-contract__otp .login__block .otp--input ::-webkit-outer-spin-button {
      -webkit-appearance: none;
              appearance: none;
      -moz-appearance: none;
    }
    .digital-contract .digital-contract__otp .login__block .col-sm-3 {
      padding-right: 10px;
      padding-left: 10px;
    }
    .digital-contract .digital-contract__otp .login__block .help-block {
      font-size: 12.1px;
    }
    .digital-contract .digital-contract__otp .login__block .description {
      margin-top: 20px;
    }
    .digital-contract .digital-contract__otp .block__info {
      position: relative;
      display: block;
      width: 90%;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid #e1e1e1;
      padding: 10px;
    }
    .digital-contract .digital-contract__otp .block__info p {
      font-size: 12.1px;
      text-align: justify;
      line-height: 1.5em;
    }
    .digital-contract .digital-contract__otp .block__info .icon {
      color: #008d45;
    }
    .digital-contract .digital-contract__otp .block__info.error--block {
      border: 1px solid #f00;
      padding: 20px;
    }
    .digital-contract .digital-contract__otp .block__info.error--block p {
      color: #f00;
    }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiConstant, },
{type: HttpClient, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'profileData': [{ type: Input },],
'loanId': [{ type: Input },],
'accessToken': [{ type: Input },],
'showModalSucessDigitalContract': [{ type: Input },],
'otp1Element': [{ type: ViewChild, args: ['otp_1', ] },],
'otp2Element': [{ type: ViewChild, args: ['otp_2', ] },],
'otp3Element': [{ type: ViewChild, args: ['otp_3', ] },],
'otp4Element': [{ type: ViewChild, args: ['otp_4', ] },],
};
}

function TNKDigitalContractComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKDigitalContractComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKDigitalContractComponent.ctorParameters;
/** @type {?} */
TNKDigitalContractComponent.propDecorators;
/** @type {?} */
TNKDigitalContractComponent.prototype.submitData;
/** @type {?} */
TNKDigitalContractComponent.prototype.isBusy;
/** @type {?} */
TNKDigitalContractComponent.prototype.submitValidation;
/** @type {?} */
TNKDigitalContractComponent.prototype.digitalSignatureData;
/** @type {?} */
TNKDigitalContractComponent.prototype.verificationSent;
/** @type {?} */
TNKDigitalContractComponent.prototype.isAgreeContractCheckbox;
/** @type {?} */
TNKDigitalContractComponent.prototype.isAgreeContract;
/** @type {?} */
TNKDigitalContractComponent.prototype.inputError;
/** @type {?} */
TNKDigitalContractComponent.prototype.contractPdfUrl;
/** @type {?} */
TNKDigitalContractComponent.prototype.numericalInputOnly;
/** @type {?} */
TNKDigitalContractComponent.prototype.profileData;
/** @type {?} */
TNKDigitalContractComponent.prototype.loanId;
/** @type {?} */
TNKDigitalContractComponent.prototype.accessToken;
/** @type {?} */
TNKDigitalContractComponent.prototype.showModalSucessDigitalContract;
/** @type {?} */
TNKDigitalContractComponent.prototype.otp1Element;
/** @type {?} */
TNKDigitalContractComponent.prototype.otp2Element;
/** @type {?} */
TNKDigitalContractComponent.prototype.otp3Element;
/** @type {?} */
TNKDigitalContractComponent.prototype.otp4Element;
/** @type {?} */
TNKDigitalContractComponent.prototype.api;
/** @type {?} */
TNKDigitalContractComponent.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
